import React from 'react';
import { MONTH_LABELS, COLOR_CLASS } from '../utils/calendarConstants';
import { getDateRange, createCell } from '../utils/calendarUtils';
import './YearView.css';

function YearView({ entries, onCellHover, onCellLeave, onCellClick, selectedDate }) {
  const { start, end } = getDateRange('year', 0);
  
  const alignedStart = new Date(start);
  alignedStart.setDate(alignedStart.getDate() - alignedStart.getDay());
  const alignedEnd = new Date(end);
  alignedEnd.setDate(alignedEnd.getDate() + (6 - alignedEnd.getDay()));

  const weeks = [];
  const monthLabels = [];
  const labelKeys = new Set();
  let current = new Date(alignedStart);
  let week = [];

  while (current <= alignedEnd) {
    const cell = createCell(current, entries, start, end);
    week.push(cell);

    if (week.length === 7) {
      weeks.push(week);
      const labelCandidate = week.find((cell) => cell.dateObj.getDate() <= 7 && !cell.isMuted);

      if (labelCandidate) {
        const labelKey = `${labelCandidate.dateObj.getFullYear()}-${labelCandidate.dateObj.getMonth()}`;
        if (!labelKeys.has(labelKey)) {
          monthLabels.push({
            column: weeks.length - 1,
            label: MONTH_LABELS[labelCandidate.dateObj.getMonth()]
          });
          labelKeys.add(labelKey);
        }
      }

      week = [];
    }

    current.setDate(current.getDate() + 1);
  }

  return (
    <div className="year-view">
      {monthLabels.length > 0 && (
        <div className="month-labels">
          {monthLabels.map((label) => (
            <span
              key={`${label.label}-${label.column}`}
              className="month-label"
            >
              {label.label}
            </span>
          ))}
        </div>
      )}

      <div className="heatmap-grid year">
        {weeks.map((week, idx) => (
          <div className="week-column" key={`week-${idx}`}>
            {week.map((cell) => (
              <button
                key={cell.isoDate}
                type="button"
                className={`day-cell ${COLOR_CLASS(cell.count, cell.isFuture)} ${cell.isMuted ? 'muted' : ''} ${
                  cell.isToday ? 'today' : ''
                } ${cell.isFuture ? 'future' : ''} ${
                  selectedDate === cell.isoDate ? 'selected' : ''
                }`}
                onMouseEnter={(event) => onCellHover(event, cell)}
                onMouseLeave={onCellLeave}
                onClick={(event) => onCellClick(event, cell)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default YearView;

